import React from 'react';
import { Button } from '../ui';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">{title || 'Confirmar exclusão'}</h2>
        <p className="text-gray-600 mb-6">{message || 'Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.'}</p>
        
        <div className="flex justify-end space-x-3">
          <Button 
            variant="outline"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button 
            variant="primary"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal; 